import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store/store";
import { setSelectedStation } from "../../../store/orm/userSession";

export function Stationselect(props: any) {
  const stations = useSelector((state: RootState) => state.stations.stations);
  const stationSelected = useSelector(
    (state: RootState) => state.stations.selectedStation,
  );
  const dispatch = useDispatch();
  // const [stationSelected, setStationSelected] = useState<any>({});
  const [selectopen, setSelectopen] = useState<boolean>(false);

  return (
    <div className="orm-stationselect text-left">
      <div>
        <div
          className="orm-stationselect__select"
          title="Bitte Station wählen - Please select a station , "
          onClick={() => setSelectopen(true)}
        >
          {stationSelected.name ? (
            <div>
              <div>
                <strong>{stationSelected.name}</strong>
              </div>
              <small className="noBreak overflowHidden textTrim">
                {stationSelected.street}, {stationSelected.city}
              </small>
            </div>
          ) : (
            <div>
              <strong>Bitte Station wählen</strong>
            </div>
          )}
          <span className="orm-station__address__icon">
            <i className="fas fa-map-marker-alt"></i>
          </span>
        </div>
        {selectopen ? (
          <div className="orm-stationselect__options">
            {stations.map((station: any) => (
              <div
                className={
                  stationSelected.id == station.id
                    ? "orm-stationselect__option selected"
                    : "orm-stationselect__option"
                }
                data-value={station.id}
                key={station.id}
                data-selected={stationSelected.id == station.id}
                onClick={() => {
                  const stationId = station.id;
                  dispatch(setSelectedStation({ type: props.type, stationId }));
                  setSelectopen(false);
                }}
                title={`${station.name} - ${station.street} , ${station.zipcode} ${station.city}`}
              >
                <div>
                  <strong>{station.name}</strong>
                </div>
                <small className="noBreak overflowHidden textTrim">
                  {station.street}, {station.city}
                </small>
              </div>
            ))}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
